import React from "react";

const ResponsiveImage = ({
  desktop,
  mobile,
  alt = "",
  priority = false,
  width,
  height,
  desktopAspect,
  mobileAspect,
  className,
}) => (
  <picture
    className="responsive-banner"
    style={{
      "--aspect-desktop": desktopAspect,
      "--aspect-mobile": mobileAspect || desktopAspect,
    }}
  >
    {mobile ? <source media="(max-width: 767px)" srcSet={mobile} /> : null}
    <img
      src={desktop}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={priority ? "high" : "low"}
    />
  </picture>
);

export default ResponsiveImage;
